module.exports = __webpack_public_path__ + "static/img/archery_vr.62c1e32.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/prj/archery_vr.png
// module id = NdKW
// module chunks = 1